<template>
  <!-- vue-toastification oblige de passer par les balises font-awesome -->
  <font-awesome-icon :icon="['fas', 'circle-xmark']" class="text-errorPrimary" />
</template>
